import React, {useEffect, useState, Suspense} from "react";
import {createMuiTheme, makeStyles} from "@material-ui/core/styles";
import {ThemeProvider} from "@material-ui/styles";
import URLSearchParams from "url-search-params";
import MomentUtils from "@date-io/moment";
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Redirect, Route, Switch, useLocation, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {IntlProvider} from "react-intl";
import "assets/vendors/style";
import indigoTheme from "./themes/indigoTheme";
import cyanTheme from "./themes/cyanTheme";
import orangeTheme from "./themes/orangeTheme";
import amberTheme from "./themes/amberTheme";
import pinkTheme from "./themes/pinkTheme";
import blueTheme from "./themes/blueTheme";
import purpleTheme from "./themes/purpleTheme";
import greenTheme from "./themes/greenTheme";
import AppLocale from "../lngProvider";

import {
    AMBER,
    BLUE,
    CYAN,
    DARK_AMBER,
    DARK_BLUE,
    DARK_CYAN,
    DARK_DEEP_ORANGE,
    DARK_DEEP_PURPLE,
    DARK_GREEN,
    DARK_INDIGO,
    DARK_PINK,
    DEEP_ORANGE,
    DEEP_PURPLE,
    GREEN,
    INDIGO,
    PINK
} from "constants/ThemeColors";
// import SignIn from "./SignIn";

// import ForgotPassword1 from "./ForgotPassword1"
// import SignUp from "./SignUp";
import Logout from "./Logout";
// import Register from "./Register";
// import Dialogclose from "../util/DialogClose2";
import {setInitUrl, userSignInSuccess, savePwa} from "../actions/Auth";
import RTL from "util/RTL";
import asyncComponent from "util/asyncComponent";
import {setDarkTheme, setThemeColor} from "../actions/Setting";
import AppLayout from "./AppLayout";
import queryString from "querystring";
import {checktoken, checktokenapi} from '../api/api.js';
import ConnectMobile from "../app/routes/reserves/routes/ReserveNew/ConnectMobile";
import AgentlistMobile from "../app/routes/reserves/routes/ReserveNew/AgentlistMobile";
import HomeDetails from "../containers/HomeDetails";
import Checksitelist from "../app/routes/homes/routes/HomesList/checksitelist";
import Checksitelistprice from "../app/routes/homes/routes/HomesList/checksitelistprice";
import Connectsites from "../app/routes/homes/routes/HomesList/connectsites2";
import CircularProgress from "@material-ui/core/CircularProgress";
import {green} from "@material-ui/core/colors";

import 'driver.js/dist/driver.css';
const SignIn = React.lazy(() => import('./SignIn'));
// const HomeDetails = React.lazy(() => import('./HomeDetails'));
const ForgotPassword1 = React.lazy(() => import('./ForgotPassword1'));
const SignUp = React.lazy(() => import('./SignUp'));
const Register = React.lazy(() => import('./Register'));
const Dialogclose = React.lazy(() => import('../util/DialogClose2'));

const useStyles = makeStyles((theme) => ({
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
}));


const RestrictedRoute = ({component: Component, authUser, ...rest}) =>
    <Route
        {...rest}
        render={props =>
            authUser
                ? <Component {...props} />
                : <Redirect
                    to={{
                        pathname: '/signin',
                        state: {from: props.location.pathname}
                    }}
                />}
    />;
const useQuery = () => new URLSearchParams(useLocation().search);
const App = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {themeColor, darkTheme, locale, isDirectionRTL} = useSelector(({settings}) => settings);
    const {authUser, initURL} = useSelector(({auth}) => auth);
    const isDarkTheme = darkTheme;
    const {match, location0} = props;
    const [checktoken, setChecktoken] = useState(false);
    const [shorttoken, setShorttoken] = useState(false);
    const [iosloading, setIosloading] = useState(false);
    const [checktokenagent, setChecktokenagent] = useState(false);
    const location = useLocation();
    const {token} = useParams();
    // useEffect(() => {
    //         alert(window.location.pathname);
    // }, []);
    const query = useQuery();

    // const email = query.get('email');

    useEffect(() => {
        if (!checktoken) {
            if (query.get('token') == null) {

            } else {
                // alert(query.get('token') + ' armin');
                // alert(location.pathname);

                var body = new FormData();
                body.append('token', query.get('token'));
                checktokenapi(body)
                    .then((response) => {

                        if (response.data.errorCode === 0) {
                            localStorage.setItem('user_id', 'Token ' + query.get('token'));
                            dispatch(userSignInSuccess(query.get('token')))
                            setChecktoken(true);
                        } else {
                            setChecktoken(false);
                        }

                    })
                    .catch((error) => {
                        debugger;

                    })
            }

            if (query.get('tokenagent') == null) {

            } else {
                var body = new FormData();
                body.append('token', query.get('token'));
                checktokenapi(body)
                    .then((response) => {
                        setChecktoken(true);
                        setChecktokenagent(true);
                        if (response.data.errorCode === 0) {
                            localStorage.setItem('user_id', 'Token ' + query.get('token'));
                            dispatch(userSignInSuccess(query.get('token')))
                        }

                    })
                    .catch((error) => {
                        debugger;

                    })
            }

            if (query.get('shortcut') == null) {

            } else {
                setShorttoken(true);

            }
        }


        if (query.get('utm_source') != null) {
            if (query.get('utm_source') === 'webapp') {
                localStorage.setItem('pwa', '1');
                dispatch(savePwa(true));
            } else {
                localStorage.setItem('pwa', '0');
                dispatch(savePwa(false));
            }
        }

        if (iOS() && query.get('utm_source') === 'webapp') {
            localStorage.setItem('ios', '1');
            setIosloading(true);
            // alert('ios');

            var delayInMilliseconds = 2000; //1 second

            setTimeout(function () {
                setIosloading(false);
                //your code to be executed after 1 second
            }, delayInMilliseconds);


        } else {
            localStorage.setItem('ios', '0');
            setIosloading(false);
        }


        if (localStorage.getItem('versionapp') == null || localStorage.getItem('versionapp') === '') {
            localStorage.setItem('versionapp', '1.0.0');
        } else {

        }


    }, []);


    useEffect(() => {

        // var query = queryString.parse(window.location.search);
        // alert(query["?token"]) ;
        window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
        if (initURL === '') {
            // alert(location.pathname);
            dispatch(setInitUrl(props.history.location.pathname));

        }
        const params = new URLSearchParams(props.location.search);
        if (params.has("theme-name")) {
            dispatch(setThemeColor(params.get('theme-name')));
        }
        if (params.has("dark-theme")) {
            dispatch(setDarkTheme());
        }
    }, [dispatch, initURL, props.history.location.pathname, props.location.search]);


    const getColorTheme = (themeColor, applyTheme) => {
        switch (themeColor) {
            case INDIGO: {
                applyTheme = createMuiTheme(indigoTheme);
                break;
            }
            case CYAN: {
                applyTheme = createMuiTheme(cyanTheme);
                break;
            }
            case AMBER: {
                applyTheme = createMuiTheme(amberTheme);
                break;
            }
            case DEEP_ORANGE: {
                applyTheme = createMuiTheme(orangeTheme);
                break;
            }
            case PINK: {
                applyTheme = createMuiTheme(pinkTheme);
                break;
            }
            case BLUE: {
                applyTheme = createMuiTheme(blueTheme);
                break;
            }
            case DEEP_PURPLE: {
                applyTheme = createMuiTheme(purpleTheme);
                break;
            }
            case GREEN: {
                applyTheme = createMuiTheme(greenTheme);
                break;
            }
            case DARK_INDIGO: {
                applyTheme = createMuiTheme({...indigoTheme, direction: 'rtl'});
                break;
            }
            case DARK_CYAN: {
                applyTheme = createMuiTheme(cyanTheme);
                break;
            }
            case DARK_AMBER: {
                applyTheme = createMuiTheme(amberTheme);
                break;
            }
            case DARK_DEEP_ORANGE: {
                applyTheme = createMuiTheme(orangeTheme);
                break;
            }
            case DARK_PINK: {
                applyTheme = createMuiTheme(pinkTheme);
                break;
            }
            case DARK_BLUE: {
                applyTheme = createMuiTheme(blueTheme);
                break;
            }
            case DARK_DEEP_PURPLE: {
                applyTheme = createMuiTheme(purpleTheme);
                break;
            }
            case DARK_GREEN: {
                applyTheme = createMuiTheme(greenTheme);
                break;
            }
            default :
                createMuiTheme(indigoTheme);
        }
        return applyTheme;
    };

    let applyTheme = createMuiTheme(indigoTheme);
    if (isDarkTheme) {
        document.body.classList.add('dark-theme');
        applyTheme = createMuiTheme(darkTheme)
    } else {
        applyTheme = getColorTheme(themeColor, applyTheme);
    }
    if (location.pathname === '/') {
        if (authUser === null) {
            return (<Redirect to={'/signin'}/>);
        } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
            return (<Redirect to={'/app/homes'}/>);
        } else {
            return (<Redirect to={initURL}/>);
        }
    }
    if (isDirectionRTL) {
        applyTheme.direction = 'rtl';
        document.body.classList.add('rtl')
    } else {
        document.body.classList.remove('rtl');
        applyTheme.direction = 'ltr';
    }

    function iOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
        <ThemeProvider theme={applyTheme}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <IntlProvider
                    locale={currentAppLocale.locale}
                    messages={currentAppLocale.messages}>
                    {/*<RTL>*/}
                    {/*    {checktoken ?*/}
                    {/*        <div className="app-main">*/}
                    {/*            {*/}
                    {/*                checktokenagent ?*/}
                    {/*                    <AgentlistMobile></AgentlistMobile>*/}
                    {/*                    :*/}
                    {/*                    <ConnectMobile></ConnectMobile>*/}

                    {/*            }*/}
                    {/*        </div>*/}
                    {/*        // null*/}
                    {/*        :*/}
                    {/*        <div style={{width: '100%', height: '100%'}}>*/}
                    {/*            {shorttoken ?*/}

                    {/*                <HomeDetails></HomeDetails>*/}

                    {/*                :*/}

                    {/*                <Suspense fallback={<div style={{height: '100%', width: '100%'}}>*/}
                    {/*                    <CircularProgress size={24} className={classes.buttonProgress}/>*/}

                    {/*                </div>}>*/}
                    {/*                    <div className="app-main">*/}
                    {/*                        <Switch>*/}
                    {/*                            <RestrictedRoute path={`${match.url}app`} authUser={authUser}*/}
                    {/*                                             component={AppLayout}/>*/}
                    {/*                            <Route path='/signin' component={SignIn}/>*/}
                    {/*                            <Route path='/forgot-password-1' component={ForgotPassword1}/>*/}
                    {/*                            <Route path='/signup' component={SignUp}/>*/}
                    {/*                            <Route path='/logout' component={Dialogclose}/>*/}
                    {/*                            <Route path='/Register' component={Register}/>*/}
                    {/*                            <Route path='/HomeDetails' component={HomeDetails}/>*/}
                    {/*                            <Route*/}
                    {/*                                component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>*/}

                    {/*                        </Switch>*/}
                    {/*                    </div>*/}
                    {/*                </Suspense>*/}
                    {/*            }*/}
                    {/*        </div>*/}
                    {/*    }*/}
                    {/*</RTL>*/}
                    <RTL>
                        <div style={{width: '100%', height: '100%'}}>
                            {iosloading ?

                                <div style={{background: '#cd2f2f'}}>


                                </div>

                                :

                                <Suspense fallback={<div style={{height: '100%', width: '100%'}}>
                                    <CircularProgress size={24} className={classes.buttonProgress}/>

                                </div>}>
                                    <div className="app-main">
                                        <Switch>
                                            <RestrictedRoute path={`${match.url}app`} authUser={authUser}
                                                             component={AppLayout}/>
                                            <Route path='/signin' component={SignIn}/>
                                            <Route path='/forgot-password-1' component={ForgotPassword1}/>
                                            <Route path='/signup' component={SignUp}/>
                                            <Route path='/logout' component={Dialogclose}/>
                                            <Route path='/Register' component={Register}/>
                                            <Route path='/HomeDetails' component={HomeDetails}/>
                                            {checktoken ?
                                                <Route path='/checksitelist' component={Checksitelist}/>
                                                :
                                                null
                                            }
                                            {checktoken ?
                                                <Route path='/checksitelistprice' component={Checksitelistprice}/>
                                                :
                                                null
                                            }
                                            {checktoken ?
                                                <Route path='/connectsites' component={Connectsites}/>
                                                :
                                                null
                                            }
                                            <Route path='/connectsites' component={Connectsites}/>
                                            <Route
                                                component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>

                                        </Switch>
                                    </div>
                                </Suspense>
                            }
                        </div>
                    </RTL>


                </IntlProvider>
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
};

export default App;
